import React from 'react';
import _ from 'underscore';

const VideoList = ({videos, onVideoAdd, playlist}) => (
  <div className="video-list">
    {console.log(videos)}
    { _.map(videos, (video) => {
      return (
        <div key={video.etag} className="video-frame">
          <h2>{video.snippet.title}</h2>
          <img src={video.snippet.thumbnails.default.url} width={video.snippet.thumbnails.default.width} height={video.snippet.thumbnails.default.height} alt={video.snippet.title}/>
          {video.id.videoId in playlist?
            (<button className="button is-success">Added</button>):
            (<button className="button is-info" onClick={() => { onVideoAdd(video.snippet.title, video.id.videoId) }}>Add</button>) 
          }
        </div>
      )
    })}
  </div>
)

export default VideoList



// WEBPACK FOOTER //
// ./src/components/VideoList.js